export var newThemesCmsMapping = {
    '56f7c38a0b19ae2e00eaab27': '4ad2735e51024f2a963e337214b36895',
    '585bac2689837620000bb230': '4ad2735e51024f2a963e337214b36895',
    '56f8e5ff2479f32000bb279a': '0b8beb6d9d044950a456670808fbb6ff',
    '585bae0a0db4e42000a4d5af': '0b8beb6d9d044950a456670808fbb6ff',
    '56f93d103f30a72e0004f8d5': '17bb6eaf73a949a0abade081f0d76f8a',
    '5682768ac18e9c32001b393e': '17bb6eaf73a949a0abade081f0d76f8a',
    '5702657d8b893b91002cde69': '1447b0d08ae54f339389d93600b48cb3',
    '56e0514d203a352000f655b4': 'df3153a0027741a497560575c38cf954',
    '56e6d6d18d7e8364002629da': 'a3e5d0f97cc14254be39cceec5bdddb6',
    '56dd4d23a23c9120000cdae0': '3824af05a2d94d049b2fdd34a444d93f',
    '56f9147e2479f32000bb279b': '8d7469989bc94c149705fd89b841a8c7',
    '56e03c0d40213a5700098eee': 'c95f7bb9230045b0b9f1078c2bed072e',
    '56e52efbe394dda300b8519c': 'df04bbd93b6d41ae8ad499fdf8db0aa0',
    '56e91b1c7471472e009ffa46': 'c6fd75a9dc1341f292c636250455b480',
    '56dd4bc6ea63ca680027c89e': 'a0ca57f916ff472d9dbd31b6f6a47f97',
    '570243aca24ae92e00ad3204': 'cda668e36069417d8a75c53ac8cf055c',
    '57b05bd92560436d00544050': 'f68efda9f95f4f108cd20f393fb00476',
    '583da350bccb132000f494e0': 'f68efda9f95f4f108cd20f393fb00476',
    '570267dce69a766d001fbb20': '8c1b8a60f05a4b138cf275471b33a889',
    '57021f5f0ac9962e00c8e5d4': '6d75e25bd8f74b8b81c028e9ce47c91e',
    '56e52be07e8ffe5b00846e59': '7135aa503abc4036aec6c68ffc0f77e9',
    '56ea6ad2688a379f00b7d1f1': '3b4fe84d33b648e79ba5529127983a1f',
    '585b8ea476bb99200039768e': '3b4fe84d33b648e79ba5529127983a1f',
    '56f26ee2596068370028f88e': 'ffd6c91234724759a3c781ee36317122',
    '579ef944a10db9520021b737': '1c874f799c5c4cbcb2dc6a96f4fdadb8',
    '56e57bfd917ec97a001e0f1a': 'd8300df8de6a43e1b2c3402e5cf958f5',
    '583ffdad07e80f1f00131c04': 'd8300df8de6a43e1b2c3402e5cf958f5',
    '57b07fc1b0ff73640098ce3e': '692e84e36b3948e386d8481c70975be0',
    '56d45a44952a2d370028a4da': '58d2020100684a8f9d99b42b06586386',
    '56e17e13f241a288009888d1': '38f506af329446808f6b0913b3051ac3',
    '570225f6e4b8ef9a00841798': '926ff10303a241aa9780df15912445eb',
    '583c283983f0cf1f003a39f8': '926ff10303a241aa9780df15912445eb',
    '56dff911433b5a5b001fe394': '40a3031c8ac942328a4f4a0f4db3c9cc',
    '571cadb3ff1cf8f8009ba1e7': 'c5a7486dfb13414eb757cea280c3abc7',
    '583ea6e5e0b8462000b2094e': 'c5a7486dfb13414eb757cea280c3abc7',
    '56dff99f9a628e8800362dd4': 'db8ba82b51774261a506bf00d2e8c2d1',
    '56a9cb909abbe1240060883c': '85be46201f94401889304800c3b66dfe',
    '584d5fbdc8e7512000dad50f': '0d12a546341b4e45acfd5d3f2aa85a8c',
    '56e7d6b101e8043700af8382': 'f9f5a1e2ecfb4fcf81e230aff6b12cd3',
    '5682a826a81c70310001c611': '1ca66d45ffa9497bb28237a0d079c52c',
    '5697e4d67bfbe94400385a70': '7e5422c14723495a98f329432a00d287',
    '568297b6208c4c310054508b': '563f7de9c0e84007b96929a0a44710d9',
    '56e59effcc38532900200577': 'cf5c80f663174fa186e661e0300744d0',
    '56a49c8dfb85744900a2b2b1': '926ff10303a241aa9780df15912445eb',
    '583ff2ab19f0982000529dac': '926ff10303a241aa9780df15912445eb',
    '56e178c9aeeaf64900372cd6': 'c6fd75a9dc1341f292c636250455b480',
    '587b7e7dc25b1014009cba44': '1c874f799c5c4cbcb2dc6a96f4fdadb8',
    '5868d4eb6764341f00cac0c6': '3824af05a2d94d049b2fdd34a444d93f',
    '56e98ace8b6487fc00c58822': 'df3153a0027741a497560575c38cf954',
    '585b9f9138645f2000226554': 'df3153a0027741a497560575c38cf954',
    '56f801b45cd1577600f36112': '0d12a546341b4e45acfd5d3f2aa85a8c',
    '56e80ad06c755b9a00887e26': 'a0ca57f916ff472d9dbd31b6f6a47f97',
    '56e964357ab3fc3700a1197f': '0d12a546341b4e45acfd5d3f2aa85a8c',
    '5682ae70a81c70310001c64c': '58d2020100684a8f9d99b42b06586386',
    '585fac6a41d27e20005b9b5e': '38f506af329446808f6b0913b3051ac3',
    '585fb8e641d27e20005b9b63': 'db8ba82b51774261a506bf00d2e8c2d1',
    '587b3a36c587ef1400686bc5': '4ad2735e51024f2a963e337214b36895',
    '587b9783c587ef1400686bca': '17bb6eaf73a949a0abade081f0d76f8a',
    '587babe4c25b1014009cba49': 'ffd6c91234724759a3c781ee36317122',
    '5869222c7f055d1f00e42a28': '8d7469989bc94c149705fd89b841a8c7',
    '56f3b343c9e0624900dfb8f1': '0d12a546341b4e45acfd5d3f2aa85a8c',
    '585b759e76bb99200039768d': '0d12a546341b4e45acfd5d3f2aa85a8c',
    f467d5835e1a4224931812483db6f97f: 'f467d5835e1a4224931812483db6f97f',
};
//# sourceMappingURL=new-themes-cms-mapping.js.map